module.exports = __webpack_public_path__ + "img/blockS2-cardT1.ff09c064.svg";